import React from 'react';

import { CardBrand } from '@portals/types';

import { ReactComponent as AmexSrc } from '../assets/img/credit-cards-logos/amex.svg';
import { ReactComponent as DinersSrc } from '../assets/img/credit-cards-logos/diners.svg';
import { ReactComponent as DiscoverSrc } from '../assets/img/credit-cards-logos/discover.svg';
import { ReactComponent as JcbSrc } from '../assets/img/credit-cards-logos/jcb.svg';
import { ReactComponent as MastercardSrc } from '../assets/img/credit-cards-logos/mastercard.svg';
import { ReactComponent as UnionpaySrc } from '../assets/img/credit-cards-logos/unionpay.svg';
import { ReactComponent as UnknownSrc } from '../assets/img/credit-cards-logos/unknown.svg';
import { ReactComponent as VisaSrc } from '../assets/img/credit-cards-logos/visa.svg';

const CARD_IMAGE = {
  [CardBrand.amex]: <AmexSrc />,
  [CardBrand.diners]: <DinersSrc />,
  [CardBrand.discover]: <DiscoverSrc />,
  [CardBrand.jcb]: <JcbSrc />,
  [CardBrand.mastercard]: <MastercardSrc />,
  [CardBrand.unionpay]: <UnionpaySrc />,
  [CardBrand.unknown]: <UnknownSrc />,
  [CardBrand.visa]: <VisaSrc />,
};

interface CreditCardLogoProps {
  brand: CardBrand;
}
export function CreditCardLogo({ brand }: CreditCardLogoProps) {
  return CARD_IMAGE[brand];
}
